import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";

interface QuestionCheckboxProps {
  isCorrectAnswer: boolean;
  handleToggleIsCorrectAnswer: (e: React.MouseEvent<HTMLDivElement>) => void;
  position: "top" | "left" | "top-left";
  isLiveMode?: boolean;
}

const POSITION_CLASSES = {
  top: "left-0 -translate-x-1/2 top-1/2 -translate-y-1/2",
  left: "left-0 -translate-x-1/2 top-1/2 -translate-y-1/2",
  "top-left": "top-2 left-2",
};

export function QuestionCheckbox({
  handleToggleIsCorrectAnswer,
  isCorrectAnswer,
  position,
  isLiveMode = false,
}: QuestionCheckboxProps) {
  return (
    <div
      onClick={(e) => handleToggleIsCorrectAnswer(e)}
      data-no-moveable-drag
      className={`absolute z-[99] ${isLiveMode ? "pointer-events-none" : "cursor-pointer"} ${POSITION_CLASSES[position]}  bg-white rounded-md border-2 shadow-md text-xl p-0.5 transition-all duration-200 hover:scale-110 ${
        isCorrectAnswer ? "border-success-500" : "border-slate-300"
      }`}
    >
      {isCorrectAnswer ? (
        <MdCheckBox className="text-success-500" />
      ) : (
        <MdCheckBoxOutlineBlank className="text-slate-400" />
      )}
    </div>
  );
}
